export default "__VITE_ASSET__CNANiKzD__"